app.constant('messages', {
    "_fallback": true,
    "login": "Login",
    "logout": "Logout",
    "password": "Password",
    "loginPasswordEmpty": "Login and password fields can't be empty",
    "selectServer": "Please select server",
    "deposit": "Deposit",
    "withdrawal": "Withdraw",
    "creditin": "Credit In",
    "creditout": "Credit Out",
    "moneyTransfer": "Money transfer",
    "cashback": "Loyalty cashback",
    "demoBalance": "Initial Deposit",
    "rememberme": "Remember me",
    "userid": "User ID",
    "server": "Server",
    "close": "Close",
    "closeTrade": "Close Trade",
    "deleteTradeBtn": "Delete",
    "deleteOrder": "Delete Order",
    "orderDeleted": "Order is deleted",
    "forgotPassword": "Forgot password",
    "normal": "Normal",
    "wide": "Wide",
    "mrms": "",
    "dateRange": {
        "day": "Today",
        "threedays": "Last 3 days",
        "week": "Last Week",
        "month": "Last Month",
        "threemonths": "Last 3 months",
        "all": "All"
    },
    "today": "Today",
    "last3days": "Last 3 days",
    "lastweek": "Last Week",
    "lastmonth": "Last month",
    "last3months": "Last 3 months",
    "all": "All",
    "daterange": "Date range",
    "day": "Day",
    "month": "Month",
    "year": "Year",
    "print": "Print",
    "openPositions": "Open Trades",
    "orders": "Orders",
    "openPosition": "Open position",
    "openPending": "Open Pending order",
    "updatePosition": "Update position",
    "closedPositions": "Closed Trades",
    "historyFor": "Trade History For",
    "closePosition": "Close position",
    "successupdated": "Successfully updated",
    "notTradeble": "Asset in not tradable",
    "execute": "Execute",
    "trade": "Trade",
    "volumeInLot": "Volume in lot",
    "volume": "Volume",
    "lots": "Lots",
    "amount": "Amount",
    "sell": "Sell",
    "limit": "Limit",
    "sell_limit": "Sell Limit",
    "sell_stop": "Sell Stop",
    "buy": "Buy",
    "stop": "Stop",
    "buy_limit": "Buy Limit",
    "buy_stop": "Buy Stop",
    "pamm": "Pamm",
    "correction": "Correction",
    "charge": "Charge",
    "commission": "Commission",
    "commission_daily": "Commission Daily",
    "commission_monthly": "Commission Monthly",
    "agent_daily": "Agent Daily",
    "agent_monthly": "Agent Monthly",
    "interestrate": "Interestrate",
    "buy_canceled": "Buy Canceled",
    "sell_canceled": "Sell Canceled",
    "dividend": "Dividend",
    "dividend_franked": "Dividend Franked",
    "tax": "Tax",
    "agent": "Agent",
    "so_compensation": "SO Compensation",
    "bonus": "Bonus",
    "btnSell": "Sell",
    "btnBuy": "Buy",
    "closeSelected": "Close selected",
    "credit": "Credit",
    "balance": "Balance",
    "netPL": "Net P/L",
    "equity": "Equity",
    "margin": "Margin",
    "usedMargin": "Used margin",
    "freeMargin": "Free margin",
    "marginLevel": "Margin level",
    "availableFunds": "Available funds",
    "usedFunds": "Used Funds",
    "accountValue": "Account Value",
    "todayFixedPL": "Today's fixed P/L",
    "orderID": "Trade Number",
    "asset": "Symbol",
    "openTime": "Opening time",
    "predictionJP": "Prediction",
    "prediction": "Prediction",
    "openRate": "Open rate",
    "closedRate": "Closed rate",
    "currentRate": "Current rate",
    "closedTime": "Closed time",
    "profit": "Profit",
    "takeProfit": "Take Profit",
    "stopLoss": "Stop loss",
    "loss": "Loss",
    "rate": "Rate",
    "action": "Type",
    "type": "Type",
    "openPrice": "Open Price",
    "closePrice": "Close Price",
    "stopLossTakeProfit": "Stop Loss / Take Profit",
    "distance": "Distance",
    "swap": "Swap",
    "chart": "Chart",
    "noChartData": "No chart data",
    "profitLoss": "Profit/Loss",
    "step1": "STEP 1 - Profit loss entry",
    "step2": "STEP 2 - Select up down prediction",
    "step3": "STEP 3 - Trade amount confirmation",
    "reset": "Reset",
    "selectall": "Select all",
    "bytick": "By Tick",
    "1min": "1 min",
    "5min": "5 min",
    "15min": "15 min",
    "30min": "30 min",
    "1hour": "1 hour",
    "4hours": "4 hours",
    "1day": "1 day",
    "1week": "1 week",
    "1month": "1 month",
    "save": "Save",
    "sounds": "Sounds",
    "positionTable": "Position table",
    "step1ToolTip": "step1ToolTip",
    "soundSettings": "View conditions of sound",
    "newOrderOpened": "New order opened",
    "closedManualy": "Position closed manually",
    "closedbyServer": "Position closed by T/P or S/L",
    "defaultValueSetting": "Default value setting for Target profit entry",
    "totalPL": "Total P/L",
    "totalDepostit": "Total depostit",
    "totalWithdrawal": "Total withdrawal",
    "noHistory": "No history for selected conditions",
    "pleaseLogin": "Please log in to show the record",
    "notLoggedIn": "Please log in to start trading",
    "connecting": "Connecting...",
    "connectionLost": "Server connection lost",
    "correctDateSelection": "Start date can't be greater than end date. <br/>Please specify correct date range.",
    "closedAt": " Closed at ",
    "at": " at ",
    "amountIn": "Amount in",
    "deleted": "deleted",
    "maxAmountLimit": "Invest amount is greater then limit amount",
    "resetZoom": "Reset zoom",
    "accountNumber": "Account number",
    "account": "Account",
    "fullname": "Full name",
    "startDate": "Start date",
    "endDate": "End date",
    "period": "Period",
    "price": "Price",
    "done": "Done",
    "openOrderComplete": "",
    "closeOrderComplete": "",
    "assetName": "asset name",
    "bid": "Bid",
    "ask": "Ask",
    "change": "Change",
    "highLow": "High/Low",
    "setYour": "set your",
    "submit": "submit",
    "closePositionNowFor": "close the position now for.",
    "currentValue": "current value",
    "requiredMargin": "Required Margin",
    "pipValue": "Pips value",
    "pointValue": "Point value",
    "pipPopup": "the affect of one pip change of your profit",
    "pointPopup": "the affect of one point change of your profit",
    "yes": "yes",
    "no": "no",
    "cancelOrder": "cancel order",
    "areYouSureCancelOrder": "are you sure you want to cancel this order?",
    "ok": "ok",
    "successful": "successful",
    "closeLoss": " Close at loss",
    "closeProfit": " Close at profit",
    "rateReach": " Open trade when rate reach",
    "rateWhen": "when rate",
    "allassets": "All assets",
    "forex": "Forex",
    "commodities": "Commodities",
    "stocks": "Stocks",
    "shares": "Stocks",
    "indices": "Indices",
    "crypto": "Crypto",
    "invalidAmount": "Invalid volume",
    "enterAmount": "Please enter a valid volume",
    "filter": "Filter",
    "tradingAlerts": "trading alerts",
    "economicCalendar": "economic calendar",
    "dailyMarketUpdate": "daily market update",
    "marginCall": "Margin Call",
    "marginCallText": "Attention! some text goes here",
    "candlestick": "Candlestick",
    "areaspline": "Line",
    "ohlc": "Ohlc",
    "correctAmount": "Enter correct amount",
    "payment": "Payment",
    "ending_with": "Ending with",
    "transfer_fr": "transfer from",
    "transfer_t": "transfer to",
    "availableTransfer": "Available to transfer",
    "actions": {
        "0": "Buy",
        "1": "Sell",
        "6": "Balance",
        "7": "Credit"
    },
    "actionsExt": {
        "0": "Buy",
        "1": "Sell",
        "6": "Balance",
        "7": "Credit"
    },
    "serverDateFormat": "DD/MM/YYYY  HH:mm:ss",
    "openDateFormat": "HH:mm:ss",
    "closeDateFormat": "DD/MM/YYYY HH:mm:ss",
    "chartToolTipFormat": "%b %e, %H:%M:%S",
    "datepickerFormat": "DD-MM-YYYY",
    "continueTrading": "Continue trading",
    "tryAgain": "Try Again",
    "addFunds": "Add funds",
    "messages": {
        "authFailed": "Invalid login or password",
        "datepickerFormat": "DD/MM/YYYY",
        "tokenFailed": "Invalid token",
        "cancelRequest": "Request canceled",
        "characters": "Only characters",
        "mixWordsNumbers": "characters or numbers",
        "authTimeout": "Authentication timeout",
        "orderProcessing": "Order is Processing",
        "orderSuccess": "Order Successfull",
        "dontSpace": "Don't use space",
        "wrongPassword": "The password does not match",
        "orderFailed": "Order execution failed",
        "loginRequired": "You login is required",
        "passwordRequired": "Enter a password",
        "registrationFailed": "Registration failed",
        "registrationSuccess": "Registration successful",
        "mt4AuthFailed": "Failed to login into trading account",
        "inappFailed": "Failed to open wallet",
        "depositFailed": "Deposit failed",
        "depositFailedText": "We could not process your deposit request. please try again",
        "depositSuccess": "Deposit success",
        "deleteOrderFailed": "Failed to delete order",
        "required": "Required",
        "too_short": "Too Short",
        "too_long": "Too Long",
        "invalid_email": "Invalid email address",
        "invalid_Firtsname": "First name is invalid",
        "invalid_Lastname": "Last Name is invalid",
        "invalid_address": "Address is invalid",
        "invalid_city": "City is invalid",
        "password_not_matched": "Passwords are not matched",
        "alphanumeric": "Please use only alphanumeric characters",
        "numbers": "Please use only digits",
        "accountNotExists": "Account with this email does not exist",
        "password_changed": "Password changed successfully",
        "email_sent": "Email sent succesfully",
        "err_password_changed": "Error change password",
        "general_error": "Problem in operation",
        "general_error_text": "We are sorry, but but your request can not be processed at this time. Please try again or contact our support team",
        "noAccounts": "No trading accounts",
        "contactSupport": "Please contact support for more information",
        "modifyTrade": "Trade was updated",
        "numbers_chars": "Numbers and characters only",
        "updateCustomerFailed": "Failed to update personal profile",
        "updateCustomerSuccess": "Personal profile successfully updated",
        "createAccountSuccess": "Account has been created successfully",
        "createAccountFailed": "Failed to create trading account",
        "initialDepositMin": "Initial deposit is too small",
        "initialDepositMax": "Initial deposit is too large",
        "transferFailed": "Failed to transfer funds between accounts",
        "transferSuccess": "Transfer funds successfully",
        "smsPhoneFailed": "Failed to send phone number",
        "smsVerificationFailed": "Invalid verification code",
        "withdrawSuccess": "Withdrawal request successful",
        "withdrawalFailed": "Failed to request withdrawal",
        "Err600": "Problem in operation",
        "Err601": "Problem in operation",
        "Err602": "Problem in operation",
        "Err603": "Problem in operation",
        "Err606": "Problem in operation",
        "Err666": "You are not logged in",
        "Err0:": "Wrong username or password",
        "Err1": "Failed to open position, try again or contact our support",
        "Err2": "Username is mandatory",
        "Err3": "Username and Password fields are mandatory",
        "Err4": "We cannot process your request, try later or contact support",
        "Err5": "An option having related trades cannot be deleted",
        "Err6": "An option having related trades cannot be deleted",
        "Err7": "Not enough funds in your balance to process withdrawal request",
        "Err8": "An error prevent completing your transaction, try later or contact support",
        "Err9": "Please enter a valid deposit amount",
        "Err10": "Deposit amount is invalid",
        "Err11": "Deposit amount must be a positive value",
        "Err12": "Your transaction has been declined. Try later or contact support",
        "Err13": "Not enough funds in your account to process your withdraw request",
        "Err14": "Your deposit request means of payment is invalid",
        "Err15": "Please enter a valid withdrawal amount",
        "Err16": "Please enter a valid withdrawal amount",
        "Err17": "Please enter a valid withdrawal amount",
        "Err18": "Your withdraw request was declined.  Try later or contact support",
        "Err19": "The system is busy, please try again later",
        "Err20": "We cannot process your request, try later or contact support",
        "Err21": "The required email already exists.",
        "Err22": "We cannot process your request, try later or contact support",
        "Err23": "Not enough funds",
        "Err24": "Cannot open trade when the market is closed",
        "Err25": "We cannot process your request, try later or contact support",
        "Err26": "Your account is prohibited to perform this action. Contact support",
        "Err29": "The invest amount is too high. Please lower your investment amount",
        "Err30": "We cannot process your request, try later or contact support",
        "Err32": "Reset password failed",
        "Err33": "General Exception",
        "Err34": "User not  exist",
        "Err35": "Trade disable due forex event",
        "Err36": "Trade disable due no quotes",
        "Err37": "Invalid deposit parameters",
        "Err49": "Only for active accounts. Would you like to deposit and start trading?",
        "Err50": "leaderID follow followerID Exists",
        "Err51": "leaderID or followerID not correct",
        "Err54": "Due to regulatory reasons, we cannot register customers from your region",
        "Err55": "Price is invalid, Would you like to reinvest on the current price?",
        "Err56": "You have tried registering with an invalid email",
        "Err57": "Payment operation was terminated, try later or contact support",
        "Err59": "Due to regulatory reasons, we cannot register customers from your region",
        "Err60": "You can't login at this time",
        "0": "",
        "1": "No change defined",
        "2": "General Error",
        "3": "Invalid Parameters",
        "4": "Technical Problem",
        "5": "",
        "6": "No Connection",
        "7": "Not Enough Rights",
        "8": "Too Many Requests",
        "9": "Malfunction Occured",
        "10": "",
        "111": "Wrong Security Session",
        "64": "Account Disabled",
        "65": "Wrong Login/password",
        "66": "",
        "128": "Trade transaction timeout expired",
        "129": "Order has wrong prices",
        "130": "Wrong stops level",
        "131": "Wrong lot size",
        "132": "Market closed",
        "133": "Trade disabled",
        "134": "There is not sufficient funds in your account for order execution. Please lower the amount or add additional funds",
        "135": "Price changed",
        "136": "No quotes",
        "137": "Broker is busy",
        "138": "Requote",
        "139": "Order is proceed by dealer and cannot be",
        "140": "Allowed only BUY orders",
        "141": "Too many requests from one client",
        "142": "Trade request accepted by server and placed in request queue",
        "143": "Trade request accepted by dealerd",
        "144": "Trade request canceled by client",
        "145": "Trade modification denied",
        "146": "Trade context is busy (used in client terminal)",
        "147": "Using expiration date denied",
        "148": "Too many orders",
        "149": "Hedge is prohibited",
        "150": "Prohibited by fifo rule",
        "1000": "",
        "1001": "No change defined",
        "1002": "General Error",
        "1003": "Invalid Parameters",
        "1004": "Technical Problem",
        "1005": "",
        "1006": "No Connection",
        "1007": "Not Enough Rights",
        "1008": "Too Many Requests",
        "1009": "Malfunction Occured",
        "1010": "",
        "1111": "Wrong Security Session",
        "1064": "Account Disabled",
        "1065": "Wrong Login/password",
        "1066": "",
        "1128": "Trade transaction timeout expired",
        "1129": "Order has wrong prices",
        "1130": "Wrong stops level",
        "1131": "Wrong lot size",
        "1132": "Market closed",
        "1133": "Trade disabled",
        "1134": "There is not sufficient funds in your account for order execution. Please lower the amount or add additional funds",
        "1135": "Price changed",
        "1136": "No quotes",
        "1137": "Broker is busy",
        "1138": "Requote",
        "1139": "Order is proceed by dealer and cannot be",
        "1140": "Allowed only BUY orders",
        "1141": "Too many requests from one client",
        "1142": "Trade request accepted by server and placed in request queue",
        "1143": "Trade request accepted by dealerd",
        "1144": "Trade request canceled by client",
        "1145": "Trade modification denied",
        "1146": "Trade context is busy (used in client terminal)",
        "1147": "Using expiration date denied",
        "1148": "Too many orders",
        "1149": "Hedge is prohibited",
        "1150": "Prohibited by fifo rule",
        "2000": "Document already approved",
        "2001": "Ticket is not assigned to customer",
        "2002": "Email already exists",
        "3006": "Invalid login or password",
        "3008": "Transaction failed",
        "3009": "Transaction failed",
        "3016": "Customer doesn't exist",
        "3021": "Customer doesn't exist",
        "3024": "Invalid amount",
        "3025": "Send SMS Failed",
        "3026": "Incorrect validation code",
        "3027": "Invalid promocode value",
        "3028": "Invalid phone number",
        "3031": "Please note you already have a pending withdrawal request.",
        "3071": "Invalid verification code",
        "3072": "Problem with sending verification email",
        "2007": "User already exists",
        "4000": "Please try again",
        "4001": "Operation failed, please try again",
        "4002": "Login failed. Try again",
        "4003": "Response timeout",
        "4004": "You must login first",
        "4005": "Fail to login account, try again in a few minutes",
        "4006": "Account not found, contact support",
        "4007": "Operation failed, please try again",
        "4008": "Operation failed, please try again",
        "4009": "General error",
        "4010": "Upload failed, please try again"
    },
    "current_rate": "Current Rate",
    "welcome": "Welcome",
    "get_started": "Get started",
    "already_member": "Already a member?",
    "log_in": "Log in",
    "forgot_password": "Forgot Password ?",
    "show_password": "Show password",
    "new_bdbfx": "New to ${brandName}?",
    "new_account": "Create a New Account",
    "login_bottom_text": "Trading FX & CFD involves substantial risk and may lead to loss of all invested capital",
    "acceptPromotions": "Accept Promotions",
    "try_again": "Try again",
    "instruments": "Instruments",
    "favorites": "Favorites",
    "add_to_favorites": "Add to favorites",
    "edit_favorites": "Edit favorites",
    "traders_trend": "Traders Trend",
    "manage_accounts": "Manage Accounts",
    "transactions": "Transactions",
    "notifications": "Notifications",
    "updatePassword": "Change Password",
    "enterCurrentPassword": "Enter current password",
    "enterNewPassword": "Enter new password",
    "reEnterPassword": "Re-enter new password",
    "price_alerts": "Price Alerts",
    "chat_withus": "Chat with Us",
    "help": "Help",
    "settings": "Settings",
    "search_placeholder": "Search...",
    "open_price": "Open",
    "market_price": "Market",
    "total_profit": "Total Profit",
    "available": "Available",
    "pending": "Pending",
    "current": "Current",
    "target": "Target",
    "pendingOrders": "Pending Orders",
    "modifyTrade": "Modify Trade",
    "modify": "Modify",
    "modifyOrder": "Modify Order",
    "difference": "Difference",
    "tradeno": "Trade No.",
    "datetime": "Date Time",
    "swap_commission": "Swap Commission",
    "market_rate": "Market Rate",
    "open_rate": "Open Rate",
    "cancel": "Cancel",
    "info": "Info",
    "underlying_asset_name": "Underlying asset name",
    "contract_expiration": "Contract_expiration",
    "spread": "Spread",
    "digits": "Digits",
    "lot_value": "Lot value",
    "min_max_volume": "Min-Max volume",
    "volume_step": "Volume step",
    "leverage": "Leverage",
    "long": "Long",
    "short": "Short",
    "trading_hours": "Trading Hours",
    "lot": "lot",
    "create_new_account": "Create a New Account",
    "account_registration": "Account Registration",
    "continue": "Continue",
    "have_account": "Already have an account?",
    "password_assistance": "Password Assistance",
    "password_assistance_text": "Enter the email address associated with your ${brandName} account",
    "email": "Your Email",
    "email_changed": "Has your email changed?",
    "email_changed_text": "If you have no longer use the e-mail address associated with your ${brandName} account, you may contact Customer Service for help restoring access to your account",
    "password_changed_text": "Please check your email",
    "password_err_changed_text": "Your new password is not correct",
    "logging_in": "Logging in...",
    "logging_out": "Logging out...",
    "starting": "Starting services...",
    "connection": "Connection problem. Attempting to reconnect. Please wait...",
    "usCitizen_text": "Are you a citizen of the United States or a resident of the U.S. Gibraltar, Guernsey, Isle of Man Jersey for tax purposes",
    "updateCustomer": "Updating customer information",
    "assesment": "Financial Suitability Questionnaire",
    "assesment_text_top": "To satisfy existing legal and regulatory requirements, we need to know a little about your relevant experience and your knowledge of investment products.",
    "trading_expirience": "Trading Experience",
    "trading_freq": "How frequently do you trade?",
    "transaction": "Transaction History",
    "date_menu": "Date",
    "action_menu": "Action",
    "method_menu": "Method",
    "withdraw": "Withdraw",
    "transfer": "Bank Transfer",
    "bank_information": "Bank Information",
    "banktransfer_instructions": "Please see below detailed wiring instructions.For you convenience, you can print these out and present to your bank, in order for them to initiate the transfer",
    "beneficiary_name": "Beneficiary Name",
    "beneficiary_address": "Beneficiary Address",
    "beneficiary_bank": "Beneficiary Bank",
    "bank_address": "Bank Address",
    "beneficiary_account_number": "Beneficiary Account Number",
    "beneficiary_iban": "Beneficiary Iban",
    "swift": "BIC / SWIFT",
    "comments": "Reference / Comments",
    "demo": "Demo",
    "live": "Live",
    "demo_account": "Demo account",
    "live_account": "Live account",
    "test": "Test",
    "click_me": "click me",
    "test_page": "Test page",
    "points": "Points",
    "pips": "Pips",
    "value": "Value",
    "amount_lots": "Amount of Lots",
    "only": "Only",
    "when_reach": "when rate reach",
    "sign_in": "Sign In",
    "emailRegistration": "Email",
    "confirmPassword": "Confirm Password",
    "firstName": "First Name",
    "middleName": "Middle Name",
    "surname": "Surname",
    "lastName": "Last Name",
    "nationalId": "National ID",
    "dateBirth": "Date of Birth",
    "iAtLeastYearsOld": "I am at least 18 years of age",
    "phone": "Phone (Without country code)",
    "phoneFull": "Phone",
    "isMobilePhone": "This is a mobile phone number",
    "country": "Country",
    "nationality": "Nationality",
    "isBirthCountry": "Place of birth is same as my nationality",
    "address": "Street Address",
    "city": "City",
    "zipCode": "Zip/Postal code",
    "usTaxId": "U.S. Tax Identification number",
    "next": "Next",
    "sharesBondsComm": "Shares, Bonds, Commodities",
    "frequently": "Frequently",
    "sometimes": "Sometimes",
    "rarely": "Rarely",
    "never": "Never",
    "have_prior_education": "Do you have prior education/experience?",
    "OTCDerivateives": "OTC Derivateives",
    "CFDForexSpreadBetting": "(CFD's, Forex, Spread Betting)",
    "exchangeTradedDerivatives": "Exchange Traded Derivatives",
    "warrantsFuturesOptions": "(Warrants, Futures Options, ETF's)",
    "iUnderstandPart1": "I understand that I will be trading only",
    "iUnderstandPart2": "CFD products with ${brandName}",
    "totalVolume": "Please indicate the total volume of deals in the above products previously undertaken per month (on averge):",
    "investKnowledge": "Investment Knowledge",
    "professionalExperience": "Do you have the experience or qualifications that assist your in understanding the risk of CFD?",
    "annualIncome": "Annual Income",
    "employmentStatus": "Employment Status",
    "employerRefrences": "We shall not contact your employer for refrences",
    "yourEmploymentStatus": "What is your employment status?",
    "atv": "What is the monthly average trade volume you intend to reach?",
    "employed": "Employed",
    "selfEmployed": "Self Employed",
    "retired": "Retired",
    "unemployedOfStudent": "Unemployed of Student",
    "financialDetails": "Financial Details",
    "anualIncome": "Anual Income",
    "valueOfSavingInvestments": "Value of Saving and Investments",
    "us_citizen": "Are you a US reportable Citizen?",
    "saveChanges": "Save Changes",
    "securePassword": "Secure password tips:",
    "useCharacters": "Use at least 6 characters, a combination of numbers and letters is best",
    "samePassword": "Do not use the same password you have used with us previously",
    "usePersonalDetails": "Do not use dictionary words, your name, e-mail address, mobile phone number or other personal information that can be easily obtained",
    "loading_deposit": "Loading wallet...",
    "wallet": "Wallet",
    "menu": "Menu",
    "back": "Back",
    "loading_closed_trades": "Loading closed trades...",
    "loading_transactions": "Loading transactions...",
    "select_country": "Select country",
    "select_nationality": "Select nationality",
    "select_citizenship": "Select citizenship",
    "select_language": "Select language",
    "no_favorites": "You don't have any favorites yet",
    "add_favorites": "Add favorites from the menu in the top bar",
    "no_pending": "You don't have any pending trades",
    "no_opentrades": "You don't have any open trades",
    "no_closetrades": "You don't have any closed trades",
    "signup": "Sign Up",
    "promo": "Promo Code",
    "continue_demo": "Continue with demo account",
    "credit-card": "Credit Card",
    "wiretransfer": "WireTransfer",
    "card_name": "Card Number",
    "card_last_digits": "Credit Card last 4 digits",
    "expiry_date": "Expiry date",
    "date": "Date",
    "transactionId": "Transaction ID",
    "depositMethod": "Deposit Method",
    "startTrading": "Start trading",
    "choosePaymentMethod": "Choose your Payment Method",
    "addTradingAccount": "Create account",
    "accountCurrency": "Currency",
    "personalDetails": "Personal Details",
    "uploadDocuments": "Upload documents",
    "helpdesk": "Help Desk",
    "transferFrom": "Transfer From",
    "transferTo": "Transfer To",
    "transferFunds": "Transfer Funds",
    "smsVerification": "SMS Verification",
    "smsCode": "Enter Code",
    "smsResend": "Resend Code",
    "withdrawFrom": "Withdraw From",
    "fundsWithdraw": "Funds to withdraw",
    "minimumAmount": "Minimum amount is",
    "maximumAmount": "Maximum amount is",
    "bankAccountInfo": "Bank Account Information",
    "bankAccountInfoText": "Please provide the bank information below",
    "bankDetails": "Bank Details",
    "bankName": "Bank Name",
    "bankAccountHolder": "Name of Account Holder",
    "bankAccountNumber": "Bank Account Number",
    "bankSwift": "ABA or SWIFT Code",
    "bankAddress": "Bank Address",
    "bankCountry": "Bank Country",
    "bankCity": "Bank City",
    "bankState": "Bank State",
    "bankStreetAddress": "Bank Street Address",
    "withdrawComments": "Enter your comments here",
    "withdrawCommentsText": "Comments (if your bank provides intermediary bank details or requires Branch Name and Branch Number for internationaly fund transfers, please provide these details below).",
    "verificationAuthenticate": "Authenticate your account by verifying your identity, payment method and address",
    "verificationCamera": "To proceed, simply upload or use your phone camera to take photos of the required documents",
    "verificationProtected": "Your details are protected and secured with us. They are kept private for the sole purpose to confirm your identity",
    "selectOne": "Select ONE of the following documents to upload",
    "photo_id": "Photo ID",
    "proof_of_identity": "Proof of Identity",
    "proof_of_residence": "Proof of Residence",
    "proof_of_payment": "Proof of Payment",
    "photo_id_front": "Photo ID Front",
    "photo_id_back": "Photo ID Back",
    "passport": "Passport",
    "driving_license": "Driving License",
    "driving_license_front": "Driving License Front",
    "driving_license_back": "Driving License Back",
    "utility_bill": "Utility Bill",
    "choose_document": "Choose a document type and upload accordingly",
    "bank_statement": "Bank Statement",
    "residence_certificate": "Residence Certificate",
    "credit_card_copy_front": "Credit Card Copy Front",
    "credit_card_copy_back": "Credit Card Copy Back",
    "credit_card_copy": "Credit Card",
    "rejected": "Rejected",
    "approved": "Approved",
    "new": "Take a photo or upload",
    "accountVerification": "Account Verification",
    "uploadInfoPicture": "Upload information and picture page",
    "file_is_big_or_small": "File is too big or too small. Please select file less than 10Mb and greater than 10Kb",
    "file_incorrect_type": "Incorrect file type. Please select one of: JPG, JPEG, PNG, Gif, PDF",
    "frozenAccount": "Frozen Account",
    "frozenAccountTitle": "Dear account holder",
    "frozenAccountText": "Your account has been frozen due to recent activity that triggered some security alert. Your account Manager will contact you shortly to reactivate your account. We apologize for the inconvenience",
    "openTradingAccount": "Open Trading Account",
    "openTradingAccountTitle": "You are one step away from start trading",
    "openTradingAccountText": "Just click below to open your first trading account",
    "all_types": "All Types",
    "all_accounts": "All Accounts",
    "filterBy": "Filter transactions by",
    "no_transactions": "You don't have any transactions",
    "check_filter": "Check transactions filter from the menu in the top bar",
    "accountType": "Account Type",
    "addNewAccount": "Add New Account",
    "switchAccount": "Switch account to:",
    "chooseAccount": "Choose the account you wish to trade",
    "distanceInPips": "Distance in pips",
    "selectAmount": "Select amount",
    "orangePayBtc": "OrangePay BTC",
    "praxis": "Deposit Funds",
    "zotapay": "Zotapay",
    "bestpaycard": "Best Pay Card",
    "solidpay": "Solid Payments",
    "completeRegistration": "Please complete the registration before you continue",
    "loading_chart": "Loading chart...",
    "smsVerificationText": "For short verification process, please enter your phone number (including country code) below to receive a sms message with PIN code",
    "jeton": "Jeton",
    "depositDemoTitle": "You are currently trading on a Demo account.",
    "depositDemoContent": "In order to make a Deposit please switch to a Live account.",
    "switchAccountButton": "Switch account",
    "creditCard": "Credit Card",
    "wireTransfer": "Wire Transfer",
    "skrill": "Skrill",
    "neteller": "NETeller",
    "other": "Other",
    "cardDetails": "Card Details",
    "website": "Website",
    "skrill_account_email": "Skrill account E-mail address",
    "neteller_account_number": "NETeller Account Number",
    "openNetellerAccount": "To open a NETeller account visit",
    "openSkrillAccount": "To open a Skrill account visit",
    "withdraw_other_label": "Please enter a payment method and details.",
    "paymentDetails": "Payment details",
    "selectPaymentMethod": "Please select your preferred payment method",
    "withdrawReason": "Withdrawal reason",
    "withdraw_reason_select": "Please select your withdrawal reason",
    "withdraw_reason_enter": "Please enter your reason",
    "withdraw_reason_300_chars": "300 characters or less",
    "withdrawalReason": {
        "withdrawingProfits": "Withdrawing profits",
        "transferringFundsToAnotherBroker": "Transferring funds to another broker",
        "unsatisfactoryService": "Unsatisfactory service",
        "limitedFunds": "Limited funds",
        "notEnoughTradingExperience": "Not enough trading experience",
        "otherReason": "Other reason"
    },
    "withdraw_history": "Withdraw History",
    "cancelledByManager": "Canceled by manager.",
    "cancelledByCustomer": "Canceled by customer",
    "status": "Status",
    "withdrawCancelSuccess": "Operation success. Request is canceled.",
    "withdrawCancelFailed": "Failed to cancel the request.",
    "withdrawRequest": "Withdraw Request",
    "cancelWithdrawal": "Are you sure you want to cancel your withdrawal request?",
    "document_other": "Other",
    "document_remove": "Remove document",
    "document_confirm_remove": "Are you sure you want to remove this document?",
    "select_account_type": "Please select one of the account types",
    "readAndAgree": "I have read and agree to",
    "kyc": "Know Your Customer Policy",
    "select": "Select",
    "state": "State",
    "citizenship": "Citizenship",
    "selectPspCurrency": "Please select deposit currency.",
    "depositUnavailableTitle": "Deposit is currently unavailable",
    "depositUnavailableContent": "Your account manager will contact you shortly",

    //for documents-v2
    "front_upload": "Front Upload",
    "front_uploaded": "Front Uploaded",
    "back_upload": "Back Upload",
    "back_uploaded": "Back Uploaded",
    "side_uploaded": "Side Uploaded",
    "doc_uploaded": "Uploaded",
    "replace_image": "Replace image",
    "proof_of_identity_text": "Select Document Type",
    "proof_of_residence_text": "Select Document Type",
    "proof_of_payment_text": "Select Document Type",
    "verification_text": "To comply with trading regulatory requirements and to protect you and us from acts of fraud, we need to verify your identity with relevant documents. <br><br> Once uploaded, the docs are in pending status and reviewed by one of our representatives. We make every effort to verify your account as quickly as possible.",
    "all_set": "No action is required at this point",
    "account_approved1": "We will let you know if we'll need any additional documents",
    "account_approved2": "No further action is required",
    "requirement_description": "Please select one of the topics below and upload accordingly",
    "pending_text": "Thanks for uploading the doc. Our team will review it soon",
    "two_sided": "Is the document two-sided?",
    "birthPlace": "Place of birth",
    "birthPlace_required": "Place of birth is required",
    "companyName_required": "Company name is required",
    "nationalId_required": "National ID is required",
    "trading_experience": "Do you have experience with investments?",
    "trades": "Trades",
    "filterClosedTrades": "Filter trades history by",
    "allTypes": "All",
    "fasapay": "FasaPay",
    "fasapay_account_name": "FasaPay Account Name",
    "fasapay_wallet_account_number": "FasaPay Wallet Account Number",
    // email verification
    "emailVerificationPart1": "We`ve sent a verification code to - ",
    "emailVerificationPart1.1": "Enter the verification code to complete your registration.",
    "emailVerificationPart2": "If you haven’t received the email, please check your spam folder or try resending the email.",
    "emailVerificationPart3": "If the email is incorrect, please",
    "emailVerificationSupport": "contact support",
    "emailVerificationPart4": "We will contact you within 24hrs",
    "insertCode": "Insert code",
    "resendEmail": "Resend email",
    "verify": "Verify",
    "requestSubmittedPart1": "Your information has been submitted.",
    "requestSubmittedPart2": "Our support team will be in touch within the next 24hrs.",
    "requestSubmittedPart3": "Thank you, %brandName% Team",
    "resendText": "Verification code has been resent"
});
